<template>
    <div class="sidebar-cart-item">
        <a :href="productUrl(cartItem.product)" class="product-image" style="margin: auto 0;">
            <img
                :src="baseImage(cartItem.product)"
                :class="{ 'image-placeholder': ! hasBaseImage(cartItem.product) }"
                alt="product image"
            >
        </a>

        <div class="product-info">
            <a :href="productUrl(cartItem.product)" class="product-name" :title="cartItem.product.name">
                {{ cartItem.product.name }}
            </a>

            <ul class="list-inline product-options">
                <li v-for="option in cartItem.options" :key="option.id">
                    <label>{{ option.name }}:</label> {{ optionValues(option) }}
                </li>
            </ul>

            <div class="product-quantity">
                {{ !cartItem.product.is_recurring ? cartItem.qty  + ' x ': ''}}<span v-html="cartItem.product.is_recurring ? (this.getCurrentPrice(cartItem) + ' / ' + $trans('storefront::product_card.month')) : this.getCurrentPrice(cartItem)"></span>
            </div>
            <div class="product-quantity" style="margin-top: -10px;">
              {{ $trans('storefront::product_card.price_plus') }}
            </div>
        </div>

        <div class="remove-cart-item">
            <button class="btn-remove" @click="remove">
                <i class="las la-times"></i>
            </button>
        </div>
    </div>
</template>

<script>
    import store from '../../store';
    import ProductHelpersMixin from '../../mixins/ProductHelpersMixin';

    export default {
        mixins: [
            ProductHelpersMixin,
        ],

        props: ['cartItem'],

        created() {
          console.log(this.cartItem);
        },

        methods: {
            getCurrentPrice(cartItem) {
              if (cartItem.product.price_type === 'Price Unit') {
                if (cartItem.product.price_ranges.length !== 0) {
                  var priceRange = cartItem.product.price_ranges.filter((el) => {
                    return parseInt(cartItem.qty) >= el.min_quantity && parseInt(cartItem.qty) <= el.max_quantity
                  })
                  if (priceRange != null && priceRange[0]?.price) {
                    return 'CHF&nbsp;' + (parseInt(cartItem.qty) * priceRange[0].price);
                  } else {
                    return 'CHF&nbsp;' + (parseInt(cartItem.qty) * cartItem.product.price_ranges[cartItem.product.price_ranges.length - 1].price);
                  }
                }
                return cartItem.unitPrice.inCurrentCurrency.formatted
              } else {
                return cartItem.total.formatted;
              }
            },

            optionValues(option) {
                let values = [];

                for (let value of option.values) {
                    values.push(value.label);
                }

                return values.join(', ');
            },

            remove() {
                store.removeCartItem(this.cartItem);

                $.ajax({
                    method: 'DELETE',
                    url: route('cart.items.destroy', { cartItemId: this.cartItem.id }),
                }).then((cart) => {
                    store.updateCart(cart);
                });
            },
        },
    };
</script>
